import styled, { css } from 'styled-components';
import { devices } from './viewports.styles';
import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { AnimatedButton } from '../animation/ButtonAnimations';
import { Step } from '../views/Step';
import { animationCss } from '../animation/Animations.styles';
import { Flow } from 'signup-constants/Flow';

const getColumnCount = currentStep => {
  switch (currentStep) {
    case 'HUBLET_SELECTION':
      return '1';

    case 'COMPANY_SIZE':
      return '3';

    default:
      return '2';
  }
};

export const ButtonsGridStyled = styled.div.withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridStyled",
  componentId: "sc-7xd3u5-0"
})(["--option-preferred-column-count:1;display:grid;grid-template-columns:repeat( var(--option-preferred-column-count),minmax(0,1fr) );grid-auto-rows:auto;grid-gap:1rem;@media ", "{--option-preferred-column-count:", ";}@media ", "{", "}", " ", " @media ", "{", "}"], devices.desktop, props => getColumnCount(props.currentStep), devices.tablet, props => props.shouldUseLayoutTemplate && `    --option-preferred-column-count:
      ${getColumnCount(props.currentStep)};`, props => props.theme.embedded && props.currentStep === Step.CompanySize && `--option-preferred-column-count: 3;`, props => props.isFramedCentredStep && `padding-top: 20px;`, devices.desktop, props => props.currentStep === Step.BusinessGoals && props.flowKey === Flow.Crm && css(["", ""], animationCss));
export const ButtonsGridButtonHolder = styled.div.withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridButtonHolder",
  componentId: "sc-7xd3u5-1"
})(["min-height:", ";min-width:0;display:grid;"], ({
  minHeight
}) => minHeight || '5rem');
export const ButtonsGridButton = styled(AnimatedButton).withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridButton",
  componentId: "sc-7xd3u5-2"
})(["height:100%;p{font-size:20px;font-weight:400;", "}", " @media ", "{p{font-size:17px;}&:focus{outline:none;box-shadow:0 0 0 2px ", ";}}@media ", "{", "}"], props => props.isACQ134Variant && `font-weight: 500;`, props => props.isFramedCentredStep && props.currentStep === Step.HubletSelection && `span {
      padding-left: 0px !important;
    }`, devices.desktop, CALYPSO_MEDIUM, devices.tablet, props => props.shouldUseLayoutTemplate && `
    p {
      font-size: 17px;
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px ${CALYPSO_MEDIUM};
    }
    `);